export enum EnumOrigemPedido {
  Loja = 'loja',
  Admin = 'admin',
  Multiloja = 'multiloja'
}
